export default {
  id: "es",
  wellcome: {
    our_mission: "Nuestra misión",
    our_vission: "Nuestra visión",
    our_values: "Nuestros valores",
    link: "https://adventisthealth.com.br/sobre-adventist-health/",
    more_information: "Mas informacion",
    vission:
      "Ser una red de salud reconocida por la excelencia en la atención médico-hospitalaria, la prevención y la promoción de un estilo de vida saludable, integrando fe y ciencia",
    mission:
      "Servir, curar y salvar, promoviendo la salud física, mental, social y espiritual, siguiendo el ejemplo de Cristo",
    values: [
      "Amor a Dios y al Prójimo",
      "Respeto a los Principios Bíblicos",
      "Integridad, Ética y Transparencia",
      "Excelencia en Servir",
      "Acogida, Cuidado y Compasión",
      "Competencia Técnica con Creatividad e Innovación",
      "Sostenibilidad Financiera, Social y Ambiental",
    ],
    slogan: "Servir, Sanar y Salvar",
    sloganLarge: ["Creer en la vida"],
  },
  login: {
    user: "Usuario",
    userPlaceholder: "Mi usuario",
    password: "Contraseña",
    passwordPlaceholder: "Mi contraseña",
    button: "Ingresar",
    quest: "¿Olvidaste la contraseña?",
    forgotMessage: "Comunicarse con TI de su institución",
    logoAdv: "",
    logoRed: "",
    logoBall: "../assets/logo_groups.gif",
    exit: "Salir",
    error: {
      server_undefined: "No es posible contactar con el servicio",
      server_error: "Tenemos problemas al validar sus credenciales",
      password: "Credenciales no válidas",
    },
  },
  loading: {
    text: "Buscando información",
  },

  common: {
    inherited:"Heredado",
    actions:"Acciones",
    customized: "Personalizado",
    configurationSystem: "Configurando el sistema para ti...",
    save: "Guardar",
    saving: "Guardando",
    loading: "Cargando",
    name: "Nombre",
    description: "Descripción",
    error: "Error",
    type: "Tipo",
    user: "Usuario",
    option: "Opción",
    options: "Opciones",
    option_short: "Opc",
    leadership: "Liderazgo",
    kpi: "Indicador",
    kpis: "Indicador | Indicadores",
    company: "Empresa",
    plan: "Planificación",
    view_complete_report_plan: "Ver Reporte Completo",
    no_report_found_plan: "No se encontró ningún reporte o no está disponible para esta planificación",
    verify_status_plan: "Verificar estado del clon",
    execute_phase_2_plan: "Ejecutar fase 2",
    sector: "Sector",
    sectors: "sectores",
    sectors_selected: "sector(es) seleccionado(s)",
    sector_s: "uno o más sectores.",
    period: "Periodo",
    state: "Estado",
    agreement: "Acuerdo",
    group: "Perspectiva",
    stereotype: "Estereotipo",
    acreditation: "Acreditación",
    perspective: "Perspectiva",
    init: "Desde",
    end: "Hasta",
    observation: "Observación",
    comment: "Comentario",
    code: "Código",
    new: "Nuevo",
    add: "Agregar",
    edit: "Editar",
    agreements: "Acuerdo | Acuerdos",
    quality: "Calidad",
    control_managment: "Gestión de control",
    provider: "Proveedor",
    client: "Cliente",
    date: "Fecha",
    clean: "Limpiar",
    delete: "Eliminar",
    defuse: "Desactivar",
    active: "Activar",
    total: "Total",
    all: "Todos",
    report: "Reporte",
    download: "Descargar",
    measure: "medida",
    history: "Historial",
    back: "Volver",
    approve: "Aprobar",
    yes: "Si",
    ok: "Ok",
    no: "No",
    points: "Puntos",
    kpi_xs: "KPI",
    search: "Buscar",
    role: "Rol",
    cancel: "Cancelar",
    update: "Actualizar",
    sorter: "Orden",
    manager: "Colaborador",
    controller: "Controller",
    avaliador: "Evaluador",
    template: "Plantilla",
    created: "Creado",
    updated: "Actualizado",
    saved: "Guardado",
    progress: "Cumplimiento",
    day: "Día",
    evaluator: "Evaluador",
    percentProgress: "Porcentage alcanzado",
    icon: "Ícono",
    factor: "Factor",
    color: "Color",
    noData: "Sin datos",
    selectAll: "Seleccionar todos",
    unselectAll: "Desmarcar todo",
    list: "Listado",
    confirm: "Confirmar",
    alert: "Alerta",
    items: "Item | Items",
    confirm_delete: "¿Seguro de eliminar? esta opción no es reversible",
    default: "Por defecto",
    view: "Ver",
    close: "Cerrar",
    retry: "Reintentar",
    format_not_supported: "Formato de archivo no soportado",
    format_see: "Formatos soportados para visualización:",
    pdf: "PDF",
    word: "Word (.docx)",
    image: "Imágenes (.jpg, .png, etc.)",
    download_any: "Puede descargar el archivo para verlo.",
    use_download: "Use el botón de descarga",
    other_formats: "Para otros formatos:",
    open_area: "Abren en una nueva pestaña",
    inline: "Visualización en línea",
    review_approved_progress: "Aprobado - En progreso",
    archive: "Archivo",
    open_with: "Después de descargarlo, ábralo con el programa apropiado.",
    word_document:
      "Documento Word - Use las barras de desplazamiento para navegar",
    exit_fullscreen: "Salir de pantalla completa",
    enter_fullscreen: "Entrar en pantalla completa",
    pdf_document:
      "Documento PDF - Use las barras de desplazamiento para navegar",
    hospital_unit: "Unidad Hospitalaria",
    no_data: "No hay datos disponibles",
    view_mode: "Modo de visualización:",
    select: "Seleccionar",
    crequired: "requeridos",
  },

  kpi: {
    dynamicPoints: "A evaluar este periodo",
    dynamicPointsInfo: "Información de puntos dinámicos",
    dynamicPointsDesc: "Los puntos se distribuyen dinámicamente según los indicadores evaluables en cada período.",
    dynamicPointsForPeriod: "Distribución de puntos para el período actual",
    evaluableKpis: "KPI evaluables",
    notScheduledThisPeriod: "No evaluado este período",
    measure_null: "Sin medición",
    notScheduledThisPeriod:"KPI no disponible para evaluar este periodo",
    scheduledThisPeriod:"KPI programado para evaluar solamente en:",
    not_applicable:"Sin Meta",
    evaluationMode:"Modo de Evaluación",
    upload_evidence: "Cargar Evidencias por Indicador",
    upload_evidence_kpi: "Cargar Evidencias por Indicador",
    upload_file: "Cargar archivo",
    upload_see: "Ver evidencias",
    upload_perspectiva: " Por Perspectiva",
    upload_name: "Nombre del archivo",
    upload_codeKpi: "Código del KPI",
    attachment_file: "Archivos adjuntos",
    not_avariable: "No disponible",
    upload_set_file: "Por favor subir un archivo",
    upload_set_name: "Por favor ingresar un nombre",
    upload_ok: "Se guardó el archivo",
    upload_ko: "Error al guardar el archivo",
    upload_delete_ok: "Se eliminó el archivo",
    upload_delete_ko: "Error al eliminar archivo",
    upload_download_ko: "Error al descargar archivo",
    upload_no_data: "No hay archivos registrados",

    stereotypes: "Estereotipos",
    acreditations: "Acreditaciones",
    result_value: "Resultado alcanzado",
    measure: "Ingrese la medida",
    write: "Ingrese su análisis aquí",
    measure_ko: "No cumplió con la meta",
    measure_ok: "Ha alcanzado la meta",
    measure_value: "Alcanzado",
    analysis: "Análisis",
    formula: "Fórmula",
    level: "Nivel",
    kpi: "Indicador",
    goal: "Meta",
    result: "Alcanzado",
    percent: "% Cumplimiento",
    media_percent: "Promedio Cumplimiento",
    method: "Método",
    check: "Evaluación",
    checker: "Evaluador",
    checked: "Evaluado",
    history: "Historial",
    history_title: "Historial de cambio",
    commentary: "Comentario",
    measure_null: "No tenemos medida aún",
    maxLength: "Cuidado con sobrepasar el límite permitido de caracteres",
    selectSector: "Seleccione un sector para continuar",
    configTitle: "Administración de indicadores",
    recalculatePoints: "Recalcular puntos",
    recalculatePointsOk: "Puntos recalculados en {count} indicador(es)",
    recalculatePointsKo: "Error al recalcular los puntos de los indicadores",
    unit: "Unidad",
    complete_no: "Sin cumplir",
    complete_yes: "Ha cumplido",
    generate: "Generar indicadores",
    result_history: "Resultado de la medición de los indicadores",
    datasheet: "Ficha técnica",
    periodicity: "Periodicidad",
    monthly: "Mensual",
    bimonthly: "Bimestral",
    quarterly: "Trimestral",
    semiannual: "Semestral",
    annual: "Anual",
    masterIdRequired: "El indicador padre es requerido",
    analysis_requires_result: "El resultado obtenido es obligatorio para guardar",
  },

  sector: {
    sector: "Sector",
    search: "Buscar sector",
    form: "Datos del sector",
    children: "Sectores asociados",
    children_ko: "No hay setores asociados",
    users: "Usuarios relacionados",
    type: "Tipo de sector",
    select_please: "Por favor seleccione un sector",
    selectSector: "Seleccione un sector para continuar",
    change: "Haga clic para cambiar de sector",
    select: "Seleccione un sector",
  },

  plan: {
    modo_view: "Modo de visualización",
    complete: "No hay pendientes para este sector",
    doing: "En progreso",
    action_plan: "Plan de acción",
    kpi: "Indicador (Indicador General KPI)",
    kpi_goal: "Meta KPI",
    kr: "KR - Resultado Clave",
    kr_actual: "R Actual",
    kr_goal: "Meta KR",
    kr_days: "Tiempo (días)",
    kr_result: "Resultado",
    reason: "¿Por qué lo hará? ",
    reason_description: "Identifique el inicio del problema",
    reason_other: "Otro motivo",
    plan_how_kr: "¿Cómo logrará el KR?",
    plan_what: "¿Qué se hará?",
    plan_how: "¿Cómo se hará?",
    plan_who: "¿Quién lo hará?",
    plan_when: "¿Cuándo se hará?",
    plan_where: "¿Dónde se hará?",
    plan_cost: "¿Cuánto costará?",
    val_attention: "Atención",
    val_how: 'Completar el "cómo" se va a lograr',
    val_what: 'Completar el "qué" se va a lograr',
    val_how_kr: 'Completar el "cómo" se va a lograr el KR',
    val_who: 'Completar el "quién" está a cargo',
    val_where: 'Completar el "dónde" se aplicará la solución',
    val_cost: 'Completar el "cúanto" costará la solución',
    val_result: "Completar el Resultado Final del Indicador para guardar",
    val_goal:"Completar la meta del PDCA",
    val_dimension: "Seleccionar la dimensión de gestión del plan de acción",
    val_init_date: "Completar la fecha de inicio",
    val_final_date: "Completar la fecha de fin",
    plan_when_description: "colocar la cantidad de días que se realizará",
    review_title: 'Revisión - Gestión de Control',
    review_revisar: 'Revisar',
    review_confirm: 'Confirmar Revisión',
    review_pending: 'Pendiente de aprobar',
    review_approved: 'Aprobado',
    review_pending_approval: 'Pendiente de aprobación',
    pending_finalization: 'PENDIENTE DE FINALIZACIÓN',
    last_measure_view: 'Consultar la última medición',
    last_measure_title: 'Última medición del indicador',
    last_measure_reference: 'Referente a',
    last_measure_value: 'Resultado',
    last_measure_registered: 'Registrada el',
    last_measure_goal_reached: 'Meta alcanzada',
    last_measure_goal_not_reached: 'Meta no alcanzada',
    last_measure_short: 'Última medición',
    last_measure_details: 'Ver detalles',
    no_info: 'No hay información para mostrar',
    no_results: 'Sin resultados',
    rules_title: '¿Qué indicadores aparecen en esta pantalla?',
    rules_1: 'Indicadores con PDCA habilitado que no alcanzaron la meta en el último período evaluado.',
    rules_2: 'Entienda las señalizaciones',
    rules_3: 'Pendiente de Creación: el indicador necesita un nuevo plan de acción (PDCA).',
    rules_4: 'Pendiente de Finalización: el indicador alcanzó la meta, pero aún tiene un PDCA abierto que debe ser concluido.',
    rules_5: 'Vencido: el PDCA superó la fecha prevista para su conclusión.',
    rules_6: 'Pendiente de Aprobación + No Ejecutado: espera la aprobación del plan por parte del Gerente del Área.',
    rules_7: 'Pendiente de Aprobación + En Progreso: espera la aprobación del resultado final por parte del Gerente del Área.',
    rules_8: 'Meta alcanzada y PDCA finalizado: el indicador deja de aparecer en esta pantalla.',
    rules_9: 'Importante: alcanzar la meta no cierra automáticamente un PDCA. Cuando haya un plan de acción abierto, seguirá disponible en esta pantalla hasta que sea debidamente finalizado.',
    review_finished: 'Finalizado',
    pending_creation: 'Pendiente de creación',
    do_init: "Fecha inicio",
    do_end: "Fecha final",
    check_advance: "Tipo de avance",
    check_pass: "Revisiones anteriores",
    collaboration: "Colaboración",
    collaboration_sector: "Sector a comunicar",
    collaboration_past: "Comunicaciones pasadas",
    act: "Comentarios para el área de calidad",
    do_not: "Plan no ejecutado",
    complete_yes: "Terminado",
    complete_no: "Terminado sin alcanzar la meta",
    progress: "En progreso",
    excluded: "Excluido",
    overdue: "Vencido",
    filterState: "Situación del plan",
    filterReview: "Revisión del plan",
    filterReviewNone: "Sin revisión",
    filterClear: "Limpiar filtro",
    filterCount: "indicador(es)",
    filterNoResults: "Ningún indicador encontrado para el filtro seleccionado",
    bureaucracy: "Burocracia en el proceso",
    training: "Falta de entramiento",
    impact: "Impacto de otra área",
    infra: "Infraestructura",
    plus: "Aumentar ",
    minus: "Disminuir",
    validate_how: 'Completar el "cómo" se va a lograr',
    validate_what: 'Completar el "qué" se va a lograr',
    validate_description: 'Completar el "cómo" se va a lograr el KR',
    validate_who: 'Completar el "quién" está a cargo',
    validate_where: 'Completar el "dónde" se aplicará la solución',
    validate_cost: 'Completar el "cuánto" costará la solución',
    pendingCreate: "Pendientes de crear",
    progressVencido: "En curso(vencido)",
    progressOnTime: "En curso(en plazo)",
    completed: "Cumplidos",
    what: "Qué",
    how: "Cómo",
    who: "Quién",
    when: "Cuándo",
    where: "Dónde",
    distributionState: "Distribución por estado",
    kpis: "Indicadores",
    in_progress: "En progreso",
    expired: "Vencidos",
    completed: "Finalizados con éxito",
    not_executed: "No ejecutados",
    not_reached: "Terminado sin alcanzar la meta",
    pending: "Pendientes",
    report: "Reporte Detallado",
    title: "Planes",
    mes: "Mes",
    semana: "Semana",
    dia: "Día",
    months: ['', 'ene', 'feb', 'mar', 'abr', 'may', 'jun', 'jul', 'ago', 'sep', 'oct', 'nov', 'dic']
  },

  risk: {
    title: "Riesgos",
    type: "Tipo de riesgo por el incumplimiento del indicador",
    patient:
      "riesgo en la experiencia del paciente por el incumplimiento del indicador",
    impact: "Impacto por incumplimiento del indicador",
    category: "Categoría ",
    operational: "Criterio operacional",
    legal: "Criterio regulatorio",
    finance: "Criterio financiero",
  },

  ose: {
    title: "OSE",
    kpi: "Datos del indicador",
    type: "Tipo de indicador",
    class: "Clasificación OSE",
    kpiType: "Tipo indicador",
    areaSelect: "Seleccione el área",
    classification: "Clasificación OSE",
    classificationSelect: "Seleccione una clasificación",
    detail: "Ingrese un detalle",
    error: "Complete el formulario",
    registed: "Registrados",
    unckecked: "pendientes",
    order: "Distribución OSE",
    kpiCount: "Cantidad de indicadores",
    chartTitle: "Cantidad de indicadores por clasificaión OSE",
    chartSubTitle: "Indicadores por OSE",
    unassigned: "Sin asignar",
    kpiList: "Listado de indicadores",
    kpiRecord: "Indicadores registrados",
    kpiPercent: "Cumplimiento porcentual",
  },

  checklist: {
    nothing: "No hay indicadores tipo CHECKLIST para este sector",
    new: "Nuevo checklist",
    edit: "Editar checklist",
    definition: "Definición del checklist",
    save: "Guardar",
    delete: "¿Seguro de eliminar? esta opción no es reversible",
    select_kpi: "Seleccionar KPI",
    nothing_selected: "No hay KPI seleccionado",
    table: {
      index: "N°",
      code: "Código",
      check: "Check",
      factor: "Prioridad",
    },
    configuration: "Configuración del checklist",
  },

  review: {
    result: "Resultado",
    controller: "Controller",
    feedback: "Evaluador",
    complete: "Cumplió la meta",
    evidence: "Evidencia",
    analysis: "Análisis",
    kpi_sector: "INDICADORES RELACIONADOS POR SECTORES",
    analysis_description: "Escriba su análisis aquí",
  },

  agreement: {
    sector: "Sector Cliente",
    desc: "Descripción del acuerdo",
    details: "Detalles de Acuerdos Interdepartamentales",
    goal: "Meta Alcanzada (≥ 100%)",
    evidence: "Evidencia",
    analysis: "Análisis",
    analysisEval: "Análisis del Evaluador",
    writeAnalysisEval: "Escribe tu análisis como evaluador...",
    analysisController:
      "Escribe tu análisis aquí basado en los acuerdos interdepartamentales...",
    resumen: "Resumen de acuerdos",
    total: "Total de acuerdos",
    totalf: "Firmados",
    complete: "Completados",
    percentage: "Cumplimiento",
    as_provider: "Mis Acuerdos Con otros-Proveedor",
    as_client: "Mis Acuerdos - Cliente",
    motive: "Motivo del contrato",
    time: "Plazo",
    preview: "Requisito previo",
    my: "Mi acuerdo",
    sign: "Firmado el ",
    complete: "Cumplió con el acuerdo",
    complete_ko: "Motivo del incumplimiento",
    confirm_message: "Confirmado el {date} por el usuario {user} ",
    confirm_title: "Confirmar acuerdo",
    new: "Nuevo acuerdo",
    edit: "Editar acuerdo",
    approve: "Aprobar acuerdo",
    review: "Evaluación del acuerdo",
    confirm_delete: "¿Esta Seguro Que desea Eliminar este acuerdo?",
    period_out: "Periodo vencido",
    title: "Nuestros Acuerdos",
    select_sector: "Seleccionar un sector",
    as_client_short: "Acuerdos como cliente",
    as_supplier_short: "Acuerdos como proveedor",
    waitSign: "Firma en espera",
    confirmSign: "Firma Confirmada",
    details: "Ver detalles",
    signedSupplier: "Firmado por el Proveedor",
    bloqued: "Acuerdo bloqueado",
    inProgress: "En progreso",
    noStarted: "No iniciado",
    completed: "Completado",
    measure: "Seguimiento del acuerdo",
    noSign: "Sin Firma",
    createNew: "Crear nuevo acuerdo",
    description: "Descripción",
    descriptionRequired: "La descripción es requerida",
    reason: "Motivo",
    reasonRequired: "El motivo es requerido",
    leadtime: "Tiempo de entrega",
    leadtimeRequired: "El tiempo de entrega es requerido",
    prerequisite: "Requisito previo",
    prerequisiteRequired: "El requisito previo es requerido",
    selectSupplier: "Seleccionar proveedor",
    selectSupplierRequired: "Debe seleccionar un proveedor",
    clientSignatoryEnabled: "¿Requiere firma del cliente?",
    clientSignatoryRequired: "La firma del cliente es requerida",
    complete_required_fields: "Por favor, complete todos los campos requeridos",
    creation_error: "Error al crear el acuerdo",
    successfull: "Acuerdo creado exitosamente",
    save: "Guardar Acuerdo",
    sectorSupplier: "Sector Proveedor",
    sectorClient: "Sector Cliente",
    sectorNoEdit: "No se puede editar el sector",
    clientSignatoryRequiredEnable: "Firma del cliente habilitada",
    loadMeasure: "Cargar medida",
    completedMeasure: "Medida completada",
    completedPercentage: "Porcentaje completado",
    nonCompliance: "Razón de Incumplimiento",
    describeNonCompliance:
      "Describa la razón por la que se dió el incumplimiento",
    measureUpd: "Actualizar medida",
    measureCreate: "Crear medida",
    measureUpdatedSuccess: "Medida actualizada correctamente",
    measureCreateSuccess: "Medida creada correctamente",
    measureCreateError: "Error al crear la medida",
    loadDetails: "Cargando detalles del acuerdo",
    dateSignClient: "Firmado por el cliente el",
    dateSignSupplier: "Firmado por el proveedor el",
    dateSignQuality: "Firmado por el área de calidad el",
    dateSignManager: "Firmado por el administrador(control) el",
    signed: "Firmar acuerdo",
    signedConfirm: "Confirmar firma",
    signedConfirmTerms:
      "¡Recuerde que la firma es irreversible, una vez aprobada no puede deshacer la firma!",
    qualityManager: "Gestión de Calidad",
    signedQuality: "Firmar acuerdo como área de Calidad",
    controlManager: "Detalles del acuerdo - Administrador",
    client: "Cliente",
    supplier: "Proveedor",
    quality: "Calidad",
    manager: "Administrador",
    signedManager: "Firmar como administrador",
    enable: "Activar Acuerdo",
    enab: "Activar",
    disable: "Desactivar Acuerdo",
    dis: "Desactivar",
    sure: "Está seguro que desea",
    this: "este acuerdo",

  },

  report: {
    title: "Reportes",
    dashboard: {
      title: "Dashboard",
      group_point: "Distribución de puntaje por perspectiva",
      stereotype_point: "Distribución de puntaje por estereotipo",
      total_point: "Total de puntos",
      percent: "Porcentaje logrado",
      kpi_detail: "Listado detallado de indicadores",
      average: "Promedio",
      fulfillment: "Desempeño de los indicadores por periodo",
      unitHospital: "Unidad Hospitalaria",
      values: "Valores",
    },
    dashboardEspecifico: {
      title: "Dashboard (Unidad)",
      distribution: "Distribución de puntaje por estereotipo",
      pointsPerKpi: "Punto por indicador",
      obtained: "Puntos obtenidos",
      totalMustBe100: "El total de la distribución no es 100. La simulación sigue válida, pero los porcentajes dejan de ser comparables con la nota oficial.",
      equalize: "Distribuir igualmente",
      useCurrent: "Usar configuración actual",
      clear: "Limpiar simulación",
      simulated: "Simulado",
      advanced: "Opciones avanzadas: factores por estereotipo",
      advancedHint: "Los estereotipos sin configuración asumen 100% por el resultado medido. Ajuste aquí para simular peso de evidencia y análisis.",
      factorComplete: "% Meta",
      factorEvidence: "% Evidencia",
      factorAnalysis: "% Análisis",
    },
    ranking: {
      title: "Ranking",
      unit: "Unidad administrativa",
      typeS: "Tipo de sectores",
      Loadtype: "Cargando tipo de sectores...",
      selectSector: "Por favor Seleccione un sector",
      selectSectorRanking:
        "Por favor seleccione un sector del árbol para ver su ranking",
      loadRank: "Cargando Ranking...",
      noSectors: "No se encontraron sectores para los filtros seleccionados",
      Sector: "Sector",
      Type: "Tipo",
      Score: "Puntuación",
      Grade: "Clasificación",
      noScore: "Sin medida",
      detKpi: "Detalles de Indicadores: ",
      rankScale: "Escala de Clasificación",
      confirm_master: 'Seleccione un sector en el panel lateral y haga clic en Generar Ranking para visualizar la clasificación.',
      stop_transaction: 'Detener transacción',
      kpi_report: 'Reporte de indicadores',
      unitHospital: 'Unidad Hospitalaria',
      generate: 'Generar Ranking',

    },
    history: {
      title: "Histórico",
      sectorTitle: "Evaluación del sector",
      sectorSubtitle: "En los periodos seleccionados",
      sectorPoint: "Puntos alcanzados",
      perspectiveTitle: "Cumplimiento por perspectiva",
      perspectiveSubtitle: "En los periodos seleccionados",
      perspectivePoint: "Porcentaje alcanzado",
    },
    accreditation: {
      title: "Acreditación",
    },
    epr: {
      title: "ERP",
      perspectiveChart: "Distribución por perspectiva",
      percent: "Porcentaje alcanzado",
      distribution: "Distribución por EPR",
      abstract: "Resumen",
      no_classification: "No clasificado",
    },
    comparative: {
      title: "Comparativo",
      graph: "Generar gráfico",
      graphTitle: "Resultado de indicadores",
      yaxis: "Valores alcanzados",
    },
  },

  integration: {
    title: "Módulo de integraciones",
    configuration: "Configuraciones",
    converters: "Conversiones",
    endpoints: "Endpoints",
    integrations: "Integraciones",
    editConverter: "Editar Tabla de Conversión",
    newConverter: "Nueva Tabla de Conversión",
    editEndpoint: "Editar Endpoint",
    newEndpoint: "Nuevo Endpoint",
    tableName: "Nombre de la tabla",
    patron: "Patrón",
    company: "Empresa",
    findSectors: "Sectores Encontrados",
    itemsChilds: "Items de Conversión por Sector Hijo",
    updSectors: "Actualizar Sectores",
    loadSectors: "Cargando sectores...",
    noFoundChilds:
      "No se encontraron sectores hijos para el sector padre seleccionado",
    valueConverted: "Ingrese el valor de conversión",
    sectorId: "ID Sector",
    sectorName: "Nombre Sector",
    sectorType: "Tipo de Sector",
    value: "Valor",
    nameRequired: "El nombre es requerido",
    errorSector: "Error al cargar los sectores hijos",
    completeWarning: "Por favor, complete todos los campos requeridos",
    noSectorWarning: "No hay sectores hijos disponibles para esta conversión",
    noTable: "No hay tablas de conversión configuradas",
    converterValues: "Valores de conversiones",
    valueTotal: "Total de Valores",
    resumen: "Resumen",
    valuesConfig: "Valores Configurados",
    noValuesConfig: "No hay items de conversión configurados para esta tabla",
    ConfirmDelete: "Confirmar Eliminación",
    confirmDeleteConverter:
      "Está seguro que desea eliminar esta tabla de conversión",
    confirmDeleteWarn:
      "Esta acción también eliminará todos los items asociados.",
    name: "Nombre",
    items: "Ítems",
    actions: "Acciones",
    endpointType: "Tipo de endpoint",
    typeRequired: "El tipo de endpoint es requerido",
    url: "URL del endpoint",
    urlRequired: "La URL del endpoint es requerido",
    pass: "Contraseña de encriptación",
    algorithm: "Algoritmo de encriptación",
    secConfig: "Configuraciones de Seguridad",
    addSecurity: "Agregar Seguridad",
    secLayer: "Capa de Seguridad",
    secType: "Tipo de Seguridad",
    addParamRequired:
      "No se requieren parámetros adicionales para este tipo de seguridad",
    noConfigSec: "No hay configuraciones de seguridad agregadas",
    noSecurity: "Sin seguridad",
    security: "Seguridad",
    new: "Nueva Integración",
    noEndpoint: "Sin endpoint",
    noLabel: "Sin etiqueta",
    noIntegration: "No se encontraron integraciones que coincidan con",
    noIntegrationConfig: "No hay integraciones configuradas",
    params: "Parámetros",
    noPatron: "Sin patrón",
    noConverters: "Sin conversiones",
    paramConfig: "Parámetros configurados",
    global: "globales",
    pers: "personalizados",
    NoparamConfig: "No hay parámetros configurados para esta integración",
    confirmDeleteInt: "Está seguro de que desea eliminar la integración",
    label: "Etiqueta",
    converter: "Conversión",
    paramType: "Tipo de parámetro",
    editInt: "Editar Integración",
    newInt: "Nueva Integración",
    noEndpoints: "No hay endpoints disponibles",
    comma: "Separado por comas",
    valueConf: "Valor/Configuración",
    jsonConf: "Configuración adicional en JSON o texto plano",
    EndpointRequired: "El endpoint es requerido",
    paramInt: "Parámetros de Integración",
    addParam: "Agregar parámetro",
    noParamTypes: "No hay tipos de parámetros disponibles",
    globalHint: "Campo deshabilitado para tipos globales",
    converterTable: "Tabla de Conversión",
    noConverterTables: "No hay tablas de conversión disponibles",
    globalType: "Tipo global",
    configParamPre: "Este tipo de parámetro usa configuración predefinida. ",
    customType: "Tipo Personalizable",
    configPatronTable:
      "Puede configurar patrón y tabla de conversión para este parámetro. ",
    paramProccess:
      "Los parámetros definen cómo se procesan los datos en la integración",
    dataSources: "Recursos de datos",
    code: "Código",
    newDataSource: "Nuevo Data Source",
    editDataSource: "Editar Data Source",
    noDataSource: "Sin fuente de datos",
    dataSource: "Data Source",
    selectEndpointFirst: "Primero seleccione un Endpoint válido",
    noDataSourcesForEndpoint: "Endpoint sin fuente de datos disponible",
    selectDataSource: "Seleccione una fuente de datos",
    param: "Parámetro",
    updateResult: "Actualizar Resultado",
    integratedResult: "Resultado Integrado",
  },

  config: {
    title: "Configuraciones",
    company: "Configuración de la compañia",
    basic: "Configuraciones basicas",
    superadmin: "Super Administrador",

    evaluationSchedule:{
      title: "Cronogramas de Evaluación",
      existingSchedules:"Lista de cronogramas",
      selectPeriods:"Seleccionar Periodos",
      schedule:"Cronogramas",
      selectedCount:"Selección de Periodos a Evaluar",
    },

    menu: {
      user: "Usuarios",
      plan: "Planificaciones",
      objetive: "Tipo de objetivos",
      sectorType: "Tipo de sectores",
      leadership: "Liderazgos",
      smtp: "SMTP",
      sectors: "Sectores",
      groups: "Perspectivas",
      periods: "Periodos",
      stereotypes: "Stereotipos",
      blocks: "Bloqueos",
      integrations: "Integraciones",
      template: "Plantillas",
      kpi: "Indicadores",
      objetives: "Objetivos",
      ranking: "Cálculos",
      accreditations: "Acreditaciones",
    },

    users: {
      title: "Gerenciamento de usuários",
      search: "Buscar usuario",
      newUser: "Nuevo usuario",
      confirmDelete: "¿Esta seguro de eliminar el usuario en la institución?",
      create: "Crear usuario",
      import: "Importar usuario",
      userExists: "Usuario ya registrado",
      personalData: "Datos personales",
      credentials: "Credenciales",
      addSector: "Agregar sector",
      successfull: "Usuario creado",
      changePassword: "Cambiar Contraseña",
      userNotFound: "Usuario no encontrado",
      userRequired: "Informe un nombre de usuario",
      userHint: "Escriba el nombre de usuario para cambiar la contraseña",
      passwordHint: "Mínimo 6 caracteres",
      minimumPassword: "La contraseña debe tener mínimo 6 caracteres",
      passwordUpdatedSuccess: "Su contraseña fue actualizada exitosamente",
      passwordUpdatedUser: "Contraseña actualizada para el usuario {username}",
      confirmPasswordChange: "Está a punto de cambiar la contraseña del usuario:\n\nNombre de usuario: {username}\nNombre: {name}\n\n¿Desea continuar?",
      assessorPermission: "Usted no tiene permiso para cambiar la contraseña de otros usuarios",
      userNotAuthenticated: "Usuario no autenticado",
      errorUpdatingPassword: "Error al actualizar la contraseña",
    },
    sector: {
      title: "Administración de sectores",
      delete: "Eliminar sector",
      deleteMessage:
        "La eliminación de un sector puede afectar mucho el sistema, por favor eliminar con responsabilidad",
    },
    sectorType: {
      title: "Administración de tipo de sector",
      kpiMark: "Etiqueta",
      level: "Nivel",
      asesor: "Evaluador",
      kpiLetter: "Letra",
      new: "Nuevo tipo de sector",
    },
    period: {
      title: "Administración de periodos",
      start: "Fecha de início",
      end: "Fecha de fin",
      from: "Desde ",
      to: "hasta",
      select: "Periodo Seleccionado",
      plural:"Periodos de Evaluación",
      perspective: "Perspectiva",
      allPerspectivesShort: "Todas las perspectivas",
      filters: "Filtros",
      listTitle: "Periodos",
      picker: {
        title: "Seleccione el periodo",
        hint: "Con todos los sectores ({count}), elija el periodo a configurar. La configuración vale para todos ellos.",
        label: "Periodo",
      },
      legend: "Leyenda de perspectivas",
      configure: "Configurar",
      view: {
        focusRole: "Rol en foco",
        focusHint: "Cambia solo la visualización de las perspectivas bloqueadas; no altera permisos.",
        showMore: "Ver las demás perspectivas bloqueadas",
      },
      summary: {
        released: "Periodos liberados",
        blocked: "Periodos bloqueados",
        partial: "Periodos parciales",
        blockedPerspectives: "Perspectivas bloqueadas",
        releasedHelp: "Todos los roles liberados en todas las perspectivas",
        blockedHelp: "Todos los roles bloqueados en todas las perspectivas",
        partialHelp: "Hay perspectivas o roles liberados y otros bloqueados",
        blockedPerspectivesHelp: "Suma, en los periodos, de las perspectivas bloqueadas para al menos un rol (Colaborador, Auditor o Evaluador)",
        undetermined: "{count} periodo(s) sin datos suficientes quedaron fuera del conteo.",
      },
      cols: {
        period: "Periodo",
        blocked: "Perspectivas bloqueadas",
        actions: "Acciones",
      },
      state: {
        released: "Liberado",
        blocked: "Bloqueado",
        partial: "Parcial",
        unknown: "No determinado",
        inheritedHelp: "Heredado: ninguna perspectiva tiene regla propia; vale el estándar del sector",
        inherit: "Heredar",
        releasedF: "Liberada",
        blockedF: "Bloqueada",
        inheritedValue: "Heredada: {state}",
        noneBlocked: "Ninguna bloqueada",
      },
      context: {
        hospital: "Hospital",
        sectorType: "Tipo de sector",
        sector: "Sector",
        sectors: "Sectores",
        period: "Periodo",
        selectedSector: "Sector seleccionado",
        allSectors: "Todos los sectores ({count})",
        sectorSearchLabel: "Sector (buscar por nombre)",
        searchSector: "Escriba el nombre del sector",
        noSectorFound: "Ningún sector encontrado",
        month: "Mes",
        sectorsCount: "{count} sectores",
      },
      drawer: {
        title: "Configuración del periodo",
        selected: "Periodo seleccionado",
        perspectives: "Perspectivas",
        bulkNotice: "Mostrando el primero de los {count} sectores como referencia. Al guardar, los cambios se aplican a todos.",
        unavailable: "No fue posible cargar la configuración de este periodo. Recargue la pantalla.",
        roleHint: "Defina qué perspectivas estarán bloqueadas para el rol de {role} en este periodo.",
        generalRule: "Regla general del rol",
        generalRuleHelp: "Vale para las perspectivas que no tienen regla propia.",
        generalCurrent: "Valor efectivo actual. No es posible saber si viene del propio sector o es heredado.",
        generalChanged: "Cambio pendiente: se guardará al presionar Guardar.",
        generalWillInherit: "Al guardar, se quitará la regla propia del sector y el valor pasará a ser heredado.",
        releaseAll: "Liberar todas",
        blockAll: "Bloquear todas",
        restore: "Restaurar estándar",
        summary: "{count} perspectiva(s) bloqueada(s) en este escenario",
        summaryNone: "Ninguna perspectiva bloqueada en este escenario",
        summaryUnknown: "{count} heredada(s) dependen de las reglas del sector y no entran en este conteo.",
        backToInherit: "Volver a heredar del estándar del sector",
        unsaved: "{count} cambio(s) sin guardar",
        save: "Guardar cambios",
        saveFirst: "Guarde los cambios antes de aplicar a otros periodos.",
        noLaterPeriods: "No hay periodos posteriores a este.",
        onlySingleSector: "Disponible solo con un sector seleccionado.",
        applyNext: "Aplicar a los próximos periodos",
        applyHelp: "Copia las reglas por perspectiva del rol seleccionado a los periodos siguientes, tras una confirmación.",
        discardTitle: "¿Descartar cambios?",
        discardText: "Hay cambios que aún no fueron guardados. Si cierra ahora, se perderán.",
        discard: "Descartar",
      },
      apply: {
        title: "Aplicar a los próximos periodos",
        role: "Rol",
        sectors: "Sectores afectados",
        perspectives: "Reglas que se copiarán",
        months: "Periodos de destino",
        warning: "Las reglas por perspectiva del rol {role} en los periodos marcados serán reemplazadas por estas. Donde dice \"Heredar\", se quitará la regla propia del destino.",
      },
      msg: {
        loadError: "No fue posible cargar los periodos.",
        retry: "Intentar de nuevo",
        saved: "Configuración guardada.",
        applied: "Configuración aplicada en {count} periodo(s).",
        partialFail: "Fallaron {failed} de {total} grabaciones.",
        forbidden: "No tiene permiso para configurar este periodo o sector.",
        failed: "Verifique la conexión e intente de nuevo.",
      },
    },
    kpi: {
      saveFirstToManageGoals: "Guarda primero el Indicador con una meta por defecto",
      evaluationScheduleHelp:"Elige el Cronograma de evaluación para este Indicador",
      title: "Formulario de edición de los indicadores",
      new: "Nuevo indicador",
      createFromTemplate: "Crear desde plantilla",
      kpiChildren: "Indicadores relacionados",
      kpiFather: "Indicador padre",
      method: "Método",
      integrations: "Integraciones",
      kpiData: "Datos del indicador",
      generalData: "Datos generales",
      pdca: "Este indicador califica para PDCA",
      delete:
        "Eliminar un KPI podría ocasionar inestabilidad en el sistema. La eliminación implica también eliminar los KPI relacionados ({count}) de otros sectores. Use con precausión",
      confirmDelete: "¿Seguro de eliminar?",
      withoutTemplate: "Sin plantilla",
      variableGoal: "Meta variable",
      variableGoalHelp: "Este KPI tendrá metas diferentes para cada período",
      managePeriodGoals: "Metas",
      periodGoals: "Metas por Período",
      noPeriodGoalsConfigured: "No hay metas configuradas para períodos específicos",
      usingDefaultGoal: "Usando meta por defecto",
      periodsConfigured: "períodos con metas configuradas",
      periodGoalsActive:"Metas por periodo activado",
      messagecreatefromtemplate: "Es necesario crear primero el KPI padre: {kpiMaster} en el sector {sectorMaster} para entonces crear el indicador {childKpi}.",
    },
    stereotype: {
      title: "Administración de Estereotipos",
      complete: "Porcentaje por cumplir la meta",
      evidence: "Porcentaje Por evidencias",
      analysis: "Porcentaje por análisis",
      delete:
        "La eliminación puede provocar inestabilidad del sistema, continue con cautela",
      syncChildren: "Aplicar a Sectores Hijos",
    },
    option: {
      syncChildren: "Aplicar a Sectores Hijos",
    },
    accreditation: {
      title: "Administración de acreditaciones",
      delete: "Eliminar acreditación",
      deleteMessage:
        "La eliminación de una acreditación puede afectar mucho el sistema, por favor eliminar con responsabilidad.",
      id_null: "Primero guarde la acreditación para gestionar sus items.",
    },
  },

  menu: {
    operational: "Analis. Operacional",
    tactic: "Analis. Tactico",
    strategic: "Analis. Estratégico",
    plan: "Planes",
    process: "Procesos",
    map: "Mapa",
    risk: "Riesgo",
    ose: "OSE",
    epr: "EPR",
    checklist: "Checks",
    advance: "Avances",
    review: "Evaluar",
    agreement: "Acuerdos",
    report: "Reportes",
    config: "Configurar",
  },

  process: {
    register: "Registro de procesos",
    add: "Agregar proceso",
    confirmDelete: "¿Seguro de eliminar?",
  },

  progress: {
    title: "Avance de completado de Indicadores",
    grade: "Evaluaciones",
    no_grade: "Sin evaluaciones",
    get_data: "Obtener información de hijos",
    close_sector: "Cerrar sector",
    close_sector_recursive: "Cerrar sector recursivamente",
    confirm:
      "¿Está seguro de que desea continuar? Esta acción no se puede deshacer.",
  },

  evaluation: {
    title: "Evaluar indicadores",
    profile: "Perfil",
    selectSector: "Seleccione un sector para continuar",
    loadKpis: "Cargando indicadores para evaluar...",
    noKpis: "No hay indicadores para evaluar en este sector",
    evaluatorAnalysis: "Análisis del evaluador",
    goalAchieved: "Resultado",
    situation: "Situación",
    situationFilter: "Filtrar por situación del indicador",
    situationEvaluated: "Evaluados",
    situationPending: "Pendientes",
    situationClear: "Limpiar filtro",
    situationCount: "indicador(es)",
    situationNoResults: "Ningún indicador encontrado para la situación seleccionada",
    situationBySector: "El sector ya ingresó los datos",
    situationByController: "Evaluado por el controller",
    situationByEvaluator: "Evaluado por el evaluador",
    situationPendingSector: "El sector aún no ingresó los datos",
    situationPendingController: "El controller aún no evaluó",
    situationPendingEvaluator: "El evaluador aún no evaluó",
  },

  epr: {
    title: "EPR",
    kpiList: "Listado de indicadores",
    slogan: "Nuestra misión",
  },

  positions: {
    leftBar: "en la barra izquierda",
    rightBar: "en la barra derecha",
    topMenu: "en el menú superior",
    bottomMenu: "en el menú inferior",
    centerPanel: "en el panel central",
    sidebar: "en la barra lateral",
    header: "en el encabezado",
    footer: "en el pie de página",
  },

  relatorio: {
    strategicTitle:  "Informe Estratégico",
    templateTitle:   "Informe por Plantilla de Indicador",
    bySetor:         "Por Sector",
    byTemplate:      "Por Indicador",
    stereotypes:     "Estereotipos",
    selectSector:    "Seleccione uno o más sectores para visualizar los indicadores",
    noData:          "No se encontraron indicadores.",
    noTemplates:     "Seleccione al menos un estereotipo o no se encontraron plantillas.",
    noKpis:          "Ningún KPI generado por esta plantilla.",
    unit:             "Unidad",
    goalReached:      "Meta alcanzada",
    goalNotReached:   "Meta no alcanzada",
    noResult:         "Sin resultado",
    evaluated:        "evaluados",
    hideFilters:      "Ocultar árbol y filtros",
    showFilters:      "Mostrar árbol y filtros",
  },
  swot: {
    initiatives: "Iniciativas",
    linkedInitiatives: "{n} iniciativa vinculada | {n} iniciativas vinculadas",
    moreInitiatives: "+ {n} iniciativa(s)",
    clickToDetail: "Haga clic para ver los detalles",
    noInitiatives: "Ninguna iniciativa vinculada a este factor.",
    loadInitiativesError: "Error al cargar las iniciativas.",
    retry: "Intentar nuevamente",
    objective: "Objetivo estratégico",
    method: "Método",
    target: "Meta",
    result: "Resultado",
    actionPlans: "{n} plan de acción | {n} planes de acción",
    openInitiative: "Abrir",
    initiativeUpdated: "¡Iniciativa actualizada con éxito!",
    strength: "Fortaleza",
    weakness: "Debilidad",
    opportunity: "Oportunidad",
    threat: "Amenaza",
  },
};